var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHardware(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 6.5H6.5V17.5H17.5V6.5ZM6.5 4.5C5.39543 4.5 4.5 5.39543 4.5 6.5V7H2V9H4.5V11H2V13H4.5V15H2V17H4.5V17.5C4.5 18.6046 5.39543 19.5 6.5 19.5H7V22H9V19.5H11V22H13V19.5H15V22H17V19.5H17.5C18.6046 19.5 19.5 18.6046 19.5 17.5V17H22V15H19.5V13H22V11H19.5V9H22V7H19.5V6.5C19.5 5.39543 18.6046 4.5 17.5 4.5H17V2H15V4.5H13V2H11V4.5H9V2H7V4.5H6.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 10.5V13.5H13.5V10.5H10.5ZM9 8.5C8.72386 8.5 8.5 8.72386 8.5 9V15C8.5 15.2761 8.72386 15.5 9 15.5H15C15.2761 15.5 15.5 15.2761 15.5 15V9C15.5 8.72386 15.2761 8.5 15 8.5H9Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardware);
export default __webpack_public_path__ + "static/media/Hardware.2a73d067.svg";
export { ForwardRef as ReactComponent };